import * as GC from '@grapecity/spread-sheets';
import { IVintageRunOff } from '@models/product-detail-report/vintage-run-off';
import { borders, colours, CURRENCY_FORMATTER, PERCENTAGE_FORMATTER } from '@shared/spread/spread-settings';

export const createProductDetailActualExport = (
  sheet: GC.Spread.Sheets.Worksheet,
  rowIndex: number,
  startCol: number,
  vintageRunOff: IVintageRunOff,
  forecastStartDate: Date,
  forecastEndDate: Date
) => {
  rowIndex = createHeaders(sheet, startCol, rowIndex);

  // trimming down data so it begins on calibration start # 7863
  vintageRunOff.VintageRunOffTimeSeries = vintageRunOff.VintageRunOffTimeSeries.filter(({ Age }) => Age >= 0);

  populateData(sheet, rowIndex, startCol, vintageRunOff, forecastStartDate, forecastEndDate);

  return rowIndex;
};

function createHeaders(sheet: GC.Spread.Sheets.Worksheet, startCol: number, rowIndex: number) {
  sheet.getCell(rowIndex, startCol).text('Dates');
  sheet.getCell(rowIndex, startCol + 1).text('Total Balance');
  sheet.getCell(rowIndex, startCol + 2).text('Coupon');
  sheet.getCell(rowIndex, startCol + 3).text('Market Rate');
  sheet.getCell(rowIndex, startCol + 4).text('Stable Balance');
  sheet.getCell(rowIndex, startCol + 5).text('Non Stable ($)');
  sheet.getCell(rowIndex, startCol + 6).text('Non Stable (%)');

  // Adding Styling
  const headerRange = sheet.getRange(rowIndex, startCol, 1, 7);
  headerRange.backColor(colours.LIGHT_GREY);
  headerRange.borderTop(borders.BLACK_MEDIUM);
  headerRange.borderLeft(borders.BLACK_MEDIUM);
  headerRange.borderRight(borders.BLACK_MEDIUM);
  headerRange.borderBottom(borders.BLACK_MEDIUM);
  headerRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
  headerRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);
  rowIndex += 1;
  return rowIndex;
}

function populateData(
  sheet: GC.Spread.Sheets.Worksheet,
  rowIndex: number,
  startCol: number,
  vintageRunOff: IVintageRunOff,
  forecastStartDate: Date,
  forecastEndDate: Date
) {


  const dates = vintageRunOff.VintageRunOffTimeSeries.map(v => v.PeriodEndDate.substr(0, 10));
  sheet.setArray(rowIndex, startCol, dates);

  const totalBalance = vintageRunOff.VintageRunOffTimeSeries.map(total => total.TotalBalance);
  sheet.setArray(rowIndex, startCol + 1, totalBalance);

  const coupon = vintageRunOff.VintageRunOffTimeSeries.map(vr => vr.CouponRate);
  sheet.setArray(rowIndex, startCol + 2, coupon);

  const marketRate = vintageRunOff.VintageRunOffTimeSeries.map(vr => vr.MarketRate);
  sheet.setArray(rowIndex, startCol + 3, marketRate);

  const stableBalance = vintageRunOff.VintageRunOffTimeSeries.map(vr => vr.StableBalance);
  sheet.setArray(rowIndex, startCol + 4, stableBalance);

  const nonStableAmount = vintageRunOff.VintageRunOffTimeSeries.map(vr => vr.NonStableBalance);
  sheet.setArray(rowIndex, startCol + 5, nonStableAmount);

  const nonStablePercent = vintageRunOff.VintageRunOffTimeSeries.map(vr => vr.NonStablePerCent);
  sheet.setArray(rowIndex, startCol + 6, nonStablePercent);

  // Adding styling
  const entireRange = sheet.getRange(rowIndex, startCol, dates.length, 7);
  entireRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
  entireRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);

  // Highlighting forecast area
  const forecastStartDateIndex = dates.findIndex(d => new Date(d).toJSON().substr(0, 7) === forecastStartDate.toJSON().substr(0, 7));
  const forecastEndDateIndex = dates.findIndex(d => d === forecastEndDate.toJSON().substr(0, 10));
  const lastObservationDateIndex = dates.findIndex(
    d => new Date(d).toJSON().substr(0, 7) === new Date(vintageRunOff.LastObservationDate).toJSON().substr(0, 7)
  );

  // Green area
  sheet
    .getRange(forecastStartDateIndex + rowIndex, startCol, forecastEndDateIndex - forecastStartDateIndex + 1, 7)
    .backColor(colours.LIGHT_GREEN);

  // Grey Overlap
  sheet
    .getRange(forecastStartDateIndex + rowIndex, startCol, lastObservationDateIndex + 1 - forecastStartDateIndex, 7)
    .backColor(colours.LIGHT_GREY);


  // Adding borders
  sheet.getRange(rowIndex, startCol, dates.length, 1).borderLeft(borders.BLACK_MEDIUM);
  sheet.getRange(rowIndex, startCol + 6, dates.length, 1).borderRight(borders.BLACK_MEDIUM);
  sheet.getRange(rowIndex + dates.length - 1, startCol, 1, 7).borderBottom(borders.BLACK_MEDIUM);

  // Adding formatters
  // Total Balance
  sheet.getRange(rowIndex, startCol + 1, totalBalance.length, 1).formatter(CURRENCY_FORMATTER);
  // Coupon
  sheet.getRange(rowIndex, startCol + 2, coupon.length, 1).formatter(PERCENTAGE_FORMATTER);
  // Market Rate
  sheet.getRange(rowIndex, startCol + 3, marketRate.length, 1).formatter(PERCENTAGE_FORMATTER);
  // Stable Balance
  sheet.getRange(rowIndex, startCol + 4, stableBalance.length, 1).formatter(CURRENCY_FORMATTER);
  // Non Stable Amount
  sheet.getRange(rowIndex, startCol + 5, nonStableAmount.length, 1).formatter(CURRENCY_FORMATTER);
  // Non Stable Percent
  sheet.getRange(rowIndex, startCol + 6, nonStablePercent.length, 1).formatter(PERCENTAGE_FORMATTER);

  rowIndex += dates.length;
  return rowIndex;
}
